import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { IS_SAAS } from "@coso/utility";
import { Observable } from "rxjs";

@Injectable()
export class HostGuard implements CanActivate {
  constructor(@Inject(IS_SAAS) private isSaaS: boolean, private router: Router) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.isSaaS) {
      this.router.navigate(["/", "404"]);
      return false;
    }
    return true;
  }
}
